import React, { useEffect, useMemo, useRef, useState } from "react"
import { Children } from "../../../../../../components/miscellianous/children"

export const BSVariantControlPanelContext = React.createContext<BSVariantControlPanelStore>({} as BSVariantControlPanelStore)

export function BSVariantControlPanelProvider({ children }: Readonly<Children>): React.JSX.Element {
  const controlPanelRef = useRef<HTMLDivElement | null>(null)
  const [controlPanelRefWidth, setControlPanelRefWidth] = useState(0)

  useEffect(() => {
    const updateWidth = () => {
      if (controlPanelRef.current) {
        setControlPanelRefWidth(controlPanelRef.current.offsetWidth + 5)
      }
    }

    updateWidth()

    const resizeObserver = new ResizeObserver(updateWidth)
    if (controlPanelRef.current) {
      resizeObserver.observe(controlPanelRef.current)
    }

    return () => {
      if (controlPanelRef.current) {
        resizeObserver.unobserve(controlPanelRef.current)
      }
    }
  }, [])

  const bsVariantControlPanelStore = useMemo(
    () => ({ controlPanelRef, controlPanelRefWidth }),
    [controlPanelRef, controlPanelRefWidth]
  )

  return (
    <BSVariantControlPanelContext.Provider value={bsVariantControlPanelStore}>
      {children}
    </BSVariantControlPanelContext.Provider>
  )
}

type BSVariantControlPanelStore = {
  controlPanelRef: React.MutableRefObject<HTMLDivElement | null>
  controlPanelRefWidth: number
}
